import {pdfjs} from "react-pdf"

// Official approach for Parcel 2
pdfjs.GlobalWorkerOptions.workerSrc = new URL("npm:pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString()
